import { render, staticRenderFns } from "./NewsPane.vue?vue&type=template&id=6a9b32b0&"
import script from "./NewsPane.vue?vue&type=script&lang=js&"
export * from "./NewsPane.vue?vue&type=script&lang=js&"
import style0 from "./NewsPane.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports